module.exports = __webpack_public_path__ + "static/media/gamer-computer.229dd1b9.jpg";